/**
 * Shared Leaflet base-layer + ring styling. Both `map/Map.tsx` (the multi-plant
 * cluster map) and `mapRing.tsx` (the single-plant embed) draw the same Google
 * satellite tiles and the same green obfuscation circle, kept here so a change
 * lands in one place instead of drifting between two hand-written copies.
 */

/** Google satellite tiles, the base layer for every DEC map. */
export const GOOGLE_SATELLITE_TILE = "https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}";
export const TILE_MAX_ZOOM = 20;

/** The plant's obfuscation ring; spread over a per-map `radius`. */
export const plantCircleStyle = {
  color: "#fff",
  weight: 6,
  fillColor: "#018f3a",
  fillOpacity: 0.13,
  interactive: false as const,
};
